import { ClientApi } from "@/api/ClientApi";
import { SalemanApi } from "@/api/SalemenApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const BuyReportFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "client_code",
                        "exludeFromSubmit": true,
                        "isHorizontal": true,
                        "label": "Codigo Cliente",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        }
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "clientId",
                        "label": "Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const clients = await ClientApi.optionsList();
                            return {
                                "-2": " Todos los clientes",
                                ...clients
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required("Seleccione ya sea un cliente o una zona de clientes"),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "salemanId",
                        "label": "Vendedor",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const salemen = await SalemanApi.optionsList();
                            return {
                                "-2": " Todos los vendedores",
                                ...salemen
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required("Seleccione un vendedor o 'Todos los vendedores'"),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "start",
                        "label": "Inicio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "end",
                        "label": "Fin",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "groupByCategory",
                        "label": "Agrupar por categoria",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    },
                ],
            ]
        }
    ],
};


export default BuyReportFormConfig;